import { Cell, Flow, Grid, HeadingSection, InfoLabel, useStyles } from 'bold-ui'
import { Divider } from 'components/divider/Divider'
import { Fragment } from 'react'

import { getPerguntasRespondidas } from '../utils-mamografia'
import {
  MAMOGRAFIA_DIAGNOSTICA_SECTIONS,
  MamografiaDiagnosticaSection,
  QuestoesRespondidasMap,
} from './model-indicacaoClinica'

export interface IndicacaoClinicaMamografiaAccordionBodyProps {
  questoesRespondidas: QuestoesRespondidasMap
  secoes: MamografiaDiagnosticaSection[]
}

export function IndicacaoClinicaMamografiaAccordionBody(props: Readonly<IndicacaoClinicaMamografiaAccordionBodyProps>) {
  const { questoesRespondidas, secoes } = props
  const { classes } = useStyles(createStyles)

  return (
    <Flow direction='vertical' style={classes.body}>
      {secoes.map(({ title, perguntas }, index) => (
        <Fragment key={title}>
          {index > 0 && <Divider style={classes.divider} />}
          {title !== MAMOGRAFIA_DIAGNOSTICA_SECTIONS[4].title && <HeadingSection level={4} vSpace={2} title={title} />}
          <Grid style={classes.grid}>
            {getPerguntasRespondidas(perguntas, questoesRespondidas).map(({ name, label, resposta, size }) => (
              <Cell key={name} size={size}>
                <InfoLabel title={label}>{resposta}</InfoLabel>
              </Cell>
            ))}
          </Grid>
        </Fragment>
      ))}
    </Flow>
  )
}

const createStyles = () => ({
  body: {
    padding: '1rem',
  },
  grid: {
    width: '100%',
  },
  divider: {
    width: '100%',
  },
})
